(function () {
  'use strict';

  var LOCKED_VIEWPORT =
    'width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=1,user-scalable=no';

  function isIOSSafari() {
    if (window.CSS && window.CSS.supports) {
      return window.CSS.supports(
        '(font:-apple-system-body) and (-webkit-touch-callout:none) and (-webkit-tap-highlight-color:hotpink)'
      );
    }

    return (
      /iPad|iPhone|iPod/.test(navigator.userAgent) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
    );
  }

  if (!isIOSSafari()) return;

  function getViewportMeta() {
    return document.querySelector('meta[name="viewport"]');
  }

  function lockViewport() {
    var meta = getViewportMeta();
    if (meta) meta.setAttribute('content', LOCKED_VIEWPORT);
  }

  function blurActiveField() {
    var active = document.activeElement;
    if (!active || active === document.body || active === document.documentElement) return;
    if (typeof active.blur !== 'function') return;
    if (!active.matches('input, textarea, select')) return;
    active.blur();
  }

  function resetSafariZoom() {
    blurActiveField();

    var meta = getViewportMeta();
    var scrollY = window.scrollY || window.pageYOffset || 0;

    if (meta) {
      meta.setAttribute(
        'content',
        'width=device-width,initial-scale=1.0001,minimum-scale=1,maximum-scale=1,user-scalable=no'
      );

      window.setTimeout(function () {
        meta.setAttribute('content', LOCKED_VIEWPORT);
        window.scrollTo(0, scrollY);
      }, 50);

      window.setTimeout(function () {
        meta.setAttribute('content', LOCKED_VIEWPORT);
        window.scrollTo(0, scrollY);
      }, 350);
    } else {
      window.scrollTo(0, scrollY);
    }
  }

  lockViewport();
  window.rabitatLockIOSViewport = lockViewport;
  window.rabitatResetSafariZoom = resetSafariZoom;

  document.addEventListener('DOMContentLoaded', lockViewport);
  window.addEventListener('load', lockViewport);
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) return;

    var entry = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    if (entry && entry.type === 'reload') {
      lockViewport();
    }
  });
})();
